/*
 * Jira Ticket:
 * Created Date: Mon, 1st Jun 2020, 12:31:42 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import {
  Create,
  required,
  SelectArrayInput,
  SimpleForm,
  TextInput,
  useQueryWithStore,
  useTranslate,
  usePermissions,
  Title,
} from 'react-admin';
import { AccessDenied } from 'Layout';
import { isSuperAdmin } from 'utils/roles';

const ConfigurationItemCreate = props => {
  const resource = 'ConfigurationItem';
  const { permissions } = usePermissions();

  return isSuperAdmin(permissions) ? (
    <>
      <Title title={`resources.General.cmsTitle`} />
      <Create {...props}>
        <SimpleForm>
          <TextInput
            source="key"
            validate={required()}
            label={`resources.${resource}.fields.key`}
            fullWidth
          />
          <TextInput
            source="value"
            validate={required()}
            label={`resources.${resource}.fields.value`}
            multiline
            fullWidth
          />
        </SimpleForm>
      </Create>
    </>
  ) : (
    <AccessDenied />
  );
};

export default ConfigurationItemCreate;
